<template>
  <div class="container">
    <navigation-card
      v-for="route in this.routes"
      :key="route.path"
      :route="route"
    />
  </div>
</template>

<script>
import navigationCard from '@/components/shared/NavigationCard'
import { dashboardRoutesFromRoutes } from '@/libraries/nav/filters'
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: { navigationCard },
  computed: {
    ...mapGetters({
      canAccessService: 'entitlements/canAccessService',
      preferences: 'preferences',
    }),
    routes () {
      // I don't know if we need to obscure the logic for dashboard routes. Happens only once
      const dashboardRoutes = dashboardRoutesFromRoutes(this.$router.options.routes)
      const authorizedRoutes = dashboardRoutes.filter(route => {
        if (route.meta.domainPreference) {
          return this.preferences[route.meta.domainPreference] && this.canAccessService(route.meta.service)
        }
        return this.canAccessService(route.meta.service)
      })
      return authorizedRoutes
    },
  },
}
</script>

<style scoped>
.container {
  padding-top: 1rem;
  height: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}

@media only screen and (max-width: 1023px) and (orientation: portrait) {
  .container {
    flex-direction: column;
  }
}
</style>
